import { useState } from 'react';

import { DeleteOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import {
	Button,
	Checkbox,
	Flex,
	Form,
	Input,
	Select,
	Tooltip,
	Typography,
} from 'antd';
import cn from 'classnames';

import styles from './styles.module.css';

type TProps = {
	keyProp: number;
	name: number;
	restField: {
		fieldKey?: number;
	};
	deleteDisabled: boolean;
	removePrompt?: (id: number | string) => void;
	remove: (index: number | number[]) => void;
	hasError?: boolean;
};

export default function QAPromptItem({
	deleteDisabled,
	keyProp,
	remove,
	name,
	restField,
	hasError,
}: TProps) {
	const [isCollapsed, setIsCollapsed] = useState(false); //useState(name > 0);

	return (
		<div
			key={keyProp}
			style={{
				// width: "max-content",
				border: `1px solid ${hasError ? '#ff4d4f' : '#ccc'}`,
				padding: '16px',
				marginBottom: '16px',
				borderRadius: '8px',
				position: 'relative',
			}}
			//   className={styles.container}
		>
			<Flex
				justify="space-between"
				align="center"
				style={{ marginBottom: isCollapsed ? 0 : '0.5rem' }}
			>
				<Typography.Title level={5} style={{ margin: 0 }}>
					Prompt {name + 1}
				</Typography.Title>

				<Flex justify="space-between" align="center" gap={8}>
					<Tooltip title="Delete Prompt" placement="left">
						<Button
							size="small"
							type="dashed"
							danger
							onClick={() => remove(name)}
							disabled={deleteDisabled}
						>
							<DeleteOutlined />
						</Button>
					</Tooltip>

					<Tooltip title="Expand/collapse" placement="left">
						<Button
							size="small"
							type="default"
							onClick={() => setIsCollapsed((cur) => !cur)}
							// style={{
							//   position: "absolute",
							//   top: "8px",
							//   right: "8px",
							// }}
						>
							{isCollapsed ? <UpOutlined /> : <DownOutlined />}
						</Button>
					</Tooltip>
				</Flex>
			</Flex>

			<div
				className={cn(
					styles.content,
					isCollapsed ? styles.closed : styles.open,
				)}
			>
				<Form.Item
					{...restField}
					name={[name, 'title']}
					label="Title"
					shouldUpdate
					rules={[
						{ required: true, message: 'Title is required.' },
						{ whitespace: true, message: 'Title cannot be empty.' },
					]}
					style={{ margin: 0 }}
				>
					<Input placeholder="Title" />
				</Form.Item>
				<Form.Item
					{...restField}
					name={[name, 'prompt']}
					label="Prompt"
					shouldUpdate
					rules={[
						{ required: true, message: 'Prompt is required.' },
						{ whitespace: true, message: 'Prompt cannot be empty.' },
					]}
					style={{ margin: 0 }}
				>
					<Input.TextArea
						placeholder="Prompt"
						rows={2}
						style={{ resize: 'none' }}
					/>
				</Form.Item>
			</div>
		</div>
	);
}
